
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_4jnkf_141",
  "disabled": "awsui_disabled_16mm3_4jnkf_157",
  "no-content-styling": "awsui_no-content-styling_16mm3_4jnkf_161",
  "expandable-header": "awsui_expandable-header_16mm3_4jnkf_167",
  "rolled-down": "awsui_rolled-down_16mm3_4jnkf_178",
  "highlighted": "awsui_highlighted_16mm3_4jnkf_181",
  "is-focused": "awsui_is-focused_16mm3_4jnkf_204",
  "visual-refresh": "awsui_visual-refresh_16mm3_4jnkf_207",
  "category": "awsui_category_16mm3_4jnkf_211",
  "expandable": "awsui_expandable_16mm3_4jnkf_167",
  "variant-navigation": "awsui_variant-navigation_16mm3_4jnkf_226",
  "expand-icon": "awsui_expand-icon_16mm3_4jnkf_233",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_4jnkf_251",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_4jnkf_254",
  "items-list-container": "awsui_items-list-container_16mm3_4jnkf_262",
  "in-dropdown": "awsui_in-dropdown_16mm3_4jnkf_271",
  "icon-wrapper": "awsui_icon-wrapper_16mm3_4jnkf_275",
  "header-content": "awsui_header-content_16mm3_4jnkf_279"
};
  